import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom";
import moment from 'moment'
import API_CONSTANTS from '../../api-constants'


const Giftcard = () => {
    const location = useLocation();
    const vouchers = location?.state?.vouchers
    const [vous, setVouchers] = useState(vouchers)
    const [selectedItem, setSelectedItem] = useState()
    const [updatedVoucher, setUpdatedVoucher] = useState()
    const [chosed, setChosed] = useState([])
    const [vouchChosed, setVouchChosed] = useState([])

    const key = sessionStorage.getItem('key')
    const [show_more, setShow_more] = useState(false)
    
    function showMore() {
        setShow_more((current => !current))
    }
    
    function appHeightChanged() {
        console.log('app height changed function')
    }
  
    function handleArrow(e, item) {
        appHeightChanged();
        setSelectedItem(item)
        if (chosed.includes(item.No) === true) {
            let newarr = chosed.filter((i) => i !== item.No)
            setChosed(newarr)
        }
        else {
            let added = [...chosed, item.No]

            setChosed(added)
        }

     //   console.log(item, 'item on clk')
        if (item.Vouchers.length === 0 || (item.Vouchers.Name == '' && item.Vouchers.LocalName == '')) {
              
            updateVouchers(item)
           
        }
    }
    //console.log(updateVoucher, 'update voucher')

    function handleVouchArrow(e, item) {
      //  console.log(item)
        if (vouchChosed.includes(item.No) === true) {
            let newarr = vouchChosed.filter((i) => i !== item.No)
            setVouchChosed(newarr)
        }
        else {
            let added = [...vouchChosed, item.No]

            setVouchChosed(added)
        }
    }

 function updateVouchers(item) {
             
     fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/UpdateVoucher?Key=${key}&BuyCode=${item.BuyCode}`, {
         method: "GET",
         headers: {
             'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
             'Content-Type': 'application/x-www-form-urlencoded',
         },  
        })
            .then((res) => res.json())
         .then((result, index) => {
                setUpdatedVoucher(result)
                //console.log(result, 'result')
                result.Name = 'test'
                let newData = [...vous]
                newData.splice(item, 1)
               // newData.unshift(result)
               // console.log(newData, 'new data')
                setVouchers([...newData, result])
              
         
            })
        
   }

    useEffect(() => {

     
        if (selectedItem && updatedVoucher) { 
        const index = vouchers.findIndex(obj => obj.No === updatedVoucher.No)
        if (index !== -1) {
            vouchers.splice(index, 1, updatedVoucher)
            }
        }
      
    }, [selectedItem, updatedVoucher])
  
  
    function totalSold(item) {
        let sum = 0
        item.Vouchers.forEach(function (value) {
            sum += value.GVXSoldAmount
        })
        return sum
    }
    function totalUsed(item) {
       
        let used = 0
        item.Vouchers.forEach(function (value ) {
            used += value.GVXUsedAmount
        })
       
        return used
    }
   
    return (
        <main>

            <p className='profile-title'>  Gavekort </p>
            <section>
                {vouchers?.map((item) => {
                   
                    return <div style={{
                        border: chosed.includes(item.No) ? '1px solid rgba(153, 153, 153, 1)' : '', borderRadius: '4px',
                        marginBottom: '25px'
                    }}>

                        <div className='giftcards' onClick={(e) => handleArrow(e, item)}  style={{ cursor: 'pointer', }} >
                            <p className='total'>
                                {totalSold(item) > 0 ? (totalSold(item) - totalUsed(item) )+ ' Kr.' :
                               item.Description ? item.Description : item.SoldCount > 1 ? item.SoldCount + ' Gavepakker ' : item.SoldCount + ' Gavepakke' }
                            </p>
                            <p className='gift'>Gavepakker</p>
                            <div className='date-container'>
                                {item.ExpireDate.substring(0, 2) == '20' ?
                                    <p className='date' style={{
                                        textAlign:'center',
                                    backgroundColor:  moment(item.ExpireDate).isBefore(moment()) ? 'rgba(157, 45, 38, 1)' : ''
                                }}>
                                        {moment(item.ExpireDate).isBefore(moment()) ? 'Udløbet' : 'Udløber' }   d. {moment(item.ExpireDate).format('DD/MM/YY')}
                                          
                                </p> 
                                : null } 
                            </div>
                            <div>
                                {chosed.includes(item.No) ?
                                    <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 9.5L9.5 1L1 9.5" stroke="white" />
                                    </svg>


                                    : <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 1L9.5 9.5L1 0.999999" stroke="white" />
                                    </svg>
                                }
                            </div>
                        </div>
                        {chosed.includes(item.No) ?
                            <>
                                <div className='giftcard-underdiv'>
                                    <p className='total-giftcards'>Indeholder <span style={{ color: 'rgba(241, 200, 149, 1)' }}>{item.SoldCount}</span> {item.SoldCount > 1 ? 'gavepakker' : 'gavepakke'} </p>


                                     <div style={{}}>
                                        <p className='boughtAt'>Købt hos: <span className='org'>{item.SoldOrgName}</span></p>
  
                                     </div>

                                    <p className='desc'>
                                        Købstidspunkt: {moment(item.SoldTime).format('DD-MM-YYYY') } (kun på kvittering)
                                        Købskode: {item.BuyCode} (kun på kvittering)<br></br>
                                        <span className='show-receipt'>Udskriv kvittering</span>
                                    </p>

                                    <p style={{ width: '20px' }}></p>
                                </div>
                              
                                {/* {(item.Vouchers.length === 0 || (item.Vouchers.Name == '' && item.Vouchers.LocalName == '')) ? updateVoucher.Vouchers.map((vouch) => (
                                //    <>
                                //        <div className='giftpackage' onClick={(e) => handleVouchArrow(e, vouch)}>
                                //            <p className='vouch-name'>{vouch.Name ? vouch.Name : vouch.LocalName}</p>
                                //            <p></p>
                                //            <p className='used'>{vouch.Used === 0 ? 'Aktivt' : 'Brugt'}</p>
                                //            {vouchChosed.includes(vouch.No) ?
                                //                <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                //                    <path d="M18 9.5L9.5 1L1 9.5" stroke="white" />
                                //                </svg>


                                //                : <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                //                    <path d="M18 1L9.5 9.5L1 0.999999" stroke="white" />
                                //                </svg>
                                //            }

                                //        </div>
                                //        {
                                //            vouchChosed.includes(vouch.No) ?
                                //                <div className='vouchQRcontainer'>
                                //                    <p className='voucher-nr'> Nummer :  <span style={{ paddingLeft: '10px' }}>{vouch.Barcode}</span></p>
                                //                    <div>
                                //                        <img width='132px' src={`https://ebillet.dk/systemnative/barcode.asmx/QRBarCode?size=8&width=180&text=${vouch.Barcode}`} />
                                //                        <button className='print'>Udskriv</button>
                                //                    </div>
                                //                    {vouch.History.length > 0 ? <p className='use-history'>Forbrughistorik:</p> : null}
                                //                    {vouch.History ? vouch.History.map((history) => {
                                //                        return <section className='history-trans'>
                                //                            <p>{moment(history.UsedDate).format('DD-MM-YYYY')} {moment(history.UsedDate).format('LT')}</p>
                                //                            <p>{history.UsedOrgName}, Transacktions-ID: { history.UsedNo}</p>
                                //                            <p>{history.UsedAmount } kr.</p>
                                //                        </section>
                                //                    }) : null }
                                                   
                                //                </div>
                                //                : null}
                                //        </>
                                //)) : */

                                    item.Vouchers.map((voucher) => (
                                     <>
                                                <div className='giftpackage' onClick={(e) => handleVouchArrow(e, voucher)}>
                                                    <p className='vouch-name'> {voucher.GVXSoldAmount > 0 ? (voucher.GVXSoldAmount - voucher.GVXUsedAmount) + ' Kr.' : null
                                                        /*voucher.Name ? voucher.Name : voucher.LocalName*/} 
                                                    {voucher.GVXSoldAmount > 0 ?
                                                        <span style={{ color: 'rgba(241, 200, 149, 1)', paddingLeft: '10px' }}> Gavekort</span> :
                                                        <span style={{ color: 'rgba(241, 200, 149, 1)', paddingLeft: '70px' }}>{voucher.Name ? voucher.Name : voucher.LocalName}</span>
                                                    }
                                                       </p>
                                            <p></p>
                                                <p className='used'>
                                                    {voucher.Used === 1  ? 'Brugt' : moment(item.ExpireDate).isBefore(moment()) ? 'Udløbet' : 'Aktivt'}</p>
                                            {vouchChosed.includes(voucher.No) ?
                                                <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18 9.5L9.5 1L1 9.5" stroke="white" />
                                                </svg>


                                                : <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M18 1L9.5 9.5L1 0.999999" stroke="white" />
                                                </svg>
                                            }

                                        </div>
                                        {
                                            vouchChosed.includes(voucher.No) ?
                                                    <div className='vouchQRcontainer' style={{ opacity: voucher.Used === 1 || moment(item.ExpireDate).isBefore(moment()) ? '0.2' : ''} }>
                                                    <p className='voucher-nr'> Nummer :  <span style={{ paddingLeft: '10px' }}>{voucher.Barcode}</span></p>
                                                    <div>
                                                        <img width='132px' src={`https://ebillet.dk/systemnative/barcode.asmx/QRBarCode?size=8&width=180&text=${voucher.Barcode}`} />
                                                            <button disabled={voucher.Used === 0 || moment(item.ExpireDate).isBefore(moment()) ? true: false} className='print'>Udskriv</button>
                                                    </div>
                                                    {voucher.History.length > 0 ? <p className='use-history'>Forbrughistorik:</p> : null}
                                                    {voucher.History ? voucher.History.map((history) => {
                                                        return <section className='history-trans'>
                                                            <p>{moment(history.UsedDate).format('DD-MM-YYYY')} {moment(history.UsedDate).format('LT')}</p>
                                                            <p>{history.UsedOrgName}, Transacktions-ID: {history.UsedNo}</p>
                                                            <p>{history.UsedAmount} kr.</p>
                                                        </section>
                                                    }) : null}
                                                </div>
                                                : null}
                                    </>
                                )

                                )
                            }

                            </>
                            : null
                        }
                    </div>
                })}
            </section>

           

        </main>
    )
}

export default Giftcard